// import { RequireAutorization } from './routerAuth'

export default {
  name: 'Invoicing',
  path: '/faturamento',
  component: () => import(/* webpackChunkName: "Invoicing" */ '@apps/invoicing/Index.vue'),
  meta: { title: 'Faturamento', subject: 'Invoice', action: 'list' },
  children: [
    {
      path: ':id/',
      name: 'InvoicingShow',
      component: () => import(/* webpackChunkName: "Invoicing" */'@apps/invoicing/Show.vue'),
      meta: { subject: 'Invoice', action: 'read' },
    },
    {
      path: ':id/editar',
      name: 'InvoicingEdit',
      component: () => import(/* webpackChunkName: "Invoicing" */'@apps/invoicing/Edit.vue'),
      meta: { subject: 'Invoice', action: 'edit' },
    },
    {
      path: 'criar',
      name: 'InvoicingNew',
      component: () => import(/* webpackChunkName: "Invoicing" */'@apps/invoicing/New.vue'),
      meta: { subject: 'Invoice', action: 'create' },
    },
  ],
  // beforeEnter: RequireAutorization
}
